module.exports = __webpack_public_path__ + "static/img/role.4fce2df.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/xk/role.png
// module id = omZw
// module chunks = 7